// extracted by mini-css-extract-plugin
module.exports = {"RecaptchaHandler":"styles_RecaptchaHandler__qbu0N","marker":"styles_marker__7QrwD"};